<template>
    <cmpRec v-bind:name="name"
                   v-bind:pkColumn="pkColumn"
                   v-bind:fields="fields"
                   v-bind:parent="parent"
                   v-bind:header="header"></cmpRec>
</template>

<script>
    import i18n from '@/i18n'
    import cmpRec from "@/components/common/cmpRec"

    export default {
        components: {
            cmpRec
        },
        computed: {
            fields() {
                return [
                    { "key": "RoleName", "label": i18n.t('component.Role.RoleName.label') },
                    { "key": "RoleDisplayName", "label": i18n.t('component.Role.RoleDisplayName.label') }
                ]
            },
            header() {
                return i18n.t('component.Role.recHeader')
            }
        },
        data() {

            return {
                name: "Role",
                pkColumn: "RoleId",
                parent: {}
            };
        }
    }
</script>